import { Link } from 'react-router-dom';

type HeaderProps = { logo: string };

const HeaderB2c = ({ logo }: HeaderProps) => {
  return (
    <header className="flex justify-between header relative">
      <Link to="/" className="flex items-center p-1">
        <img src={logo} alt="" className="h-16 mb-auto" />
      </Link>
      <div className="p-1 text-sm text-right flex flex-col justify-between"></div>
    </header>
  );
};

export default HeaderB2c;
